// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"layout_layoutWrapper__OtbND","layoutMain":"layout_layoutMain__4ozn_"};